import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./boxed.css.ts.vanilla.css-mistica.js";
var e = "_1y2v1nfk1", a = "ihbkeqk", r = "ihbkeqm", b = {
    width: "var(--ihbkeq0)",
    height: "var(--ihbkeq1)",
    minHeight: "var(--ihbkeq2)",
    maxWidth: "var(--ihbkeq3)",
    minWidth: "var(--ihbkeq4)",
    mobile: {
        width: "var(--ihbkeq5)",
        height: "var(--ihbkeq6)",
        minHeight: "var(--ihbkeq7)",
        maxWidth: "var(--ihbkeq8)",
        minWidth: "var(--ihbkeq9)"
    },
    tablet: {
        width: "var(--ihbkeqa)",
        height: "var(--ihbkeqb)",
        minHeight: "var(--ihbkeqc)",
        maxWidth: "var(--ihbkeqd)",
        minWidth: "var(--ihbkeqe)"
    },
    desktop: {
        width: "var(--ihbkeqf)",
        height: "var(--ihbkeqg)",
        minHeight: "var(--ihbkeqh)",
        maxWidth: "var(--ihbkeqi)",
        minWidth: "var(--ihbkeqj)"
    }
};
export { e as boxBorder, a as boxed, r as desktopOnly, b as vars };
